/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".detailsListDragDropExample .dragEnter{background-color:"},{"theme":"neutralLight","defaultValue":"#eaeaea"},{"rawString":"}\n"}]);